import './SettlementEmailHeader.css';

export const SettlementEmailHeader = (props: {
  header: string;
  onRestoreClick: () => void;
}) => {
  return (
    <div className="settlement-email-template__header">
      <h2>{props.header}</h2>
      <button
        className="settlement-email-template__restore"
        onClick={props.onRestoreClick}
      >
        Restore default
      </button>
    </div>
  );
};
